import * as actions from '../../store/state/actions/action-creators';
import { CONTAINER_NAMES, getDataContextName } from '../../container/container-utils';
import { getParentContextName } from '../../utils/context-utils';
import { getContainerNameFromContainerItemID } from '../common-helper';
import type { Action } from '../../store/state/state-manager';
import type { DxAPIResponseObject } from '../types';
import type { Actionout } from '../../types';
import constants from '../../constants';

export const getContainerName = (actionInPayload: Action['payload']) => {
  const { isModalAction, containerItemID } = actionInPayload;
  return isModalAction ? CONTAINER_NAMES.MODAL : getContainerNameFromContainerItemID(containerItemID);
};

export const addActionToUpdateParentContextCaseViewMode = async (
  actionsOut: Actionout[],
  options: {
    childContainerItemID: string;
    caseViewMode: string;
    referencedUsers: object | object[];
    response: DxAPIResponseObject;
  }
) => {
  const { childContainerItemID, caseViewMode, referencedUsers, response } = options;
  const parentContainerItemID = getParentContextName(childContainerItemID);
  const parentContextName = getDataContextName(parentContainerItemID);

  let hasAssignments = false;
  const caseInfo = response?.data?.caseInfo;
  if (caseInfo) {
    hasAssignments = Object.prototype.hasOwnProperty.call(caseInfo, 'assignments');
    caseInfo.assignments ??= [];
  }

  const actionPayload = {
    context: parentContextName,
    data: {
      ...response.data,
      referencedUsers,
      context_data: {
        caseViewMode
      }
    }
  };

  const propertiesToReplace: { path: string; allowMultiple: boolean }[] = [];
  if (hasAssignments) {
    // If the dx api explicitly included an assignments property, ask mergeData to
    // replace the entire assignments array rather than deep-merging it.
    propertiesToReplace.push({ path: constants.CASE_INFO.ASSIGNMENTS, allowMultiple: true });
  }

  if (propertiesToReplace.length > 0) {
    actionsOut.push(actions.postProcess(actions.mergeData, actionPayload, { propertiesToReplace }));
  } else {
    actionsOut.push(actions.postProcess(actions.mergeData, actionPayload));
  }
};
